module.exports = __webpack_public_path__ + "img/perform_3.66655ec7.svg";